<template>
  <div>
    <b-modal
      id="change-password-modal"
      title="Change password"
      centered
    >
      <PasswordRePasswordComponent ref="passwordRePasswordRef" />

      <div
        slot="modal-footer"
        class="w-100"
      >
        <b-btn
          id="footer-button"
          size="xl"
          variant="primary"
          enabled="!showLoading"
          @click="clickedSubmit()"
        >
          <i
            v-show="showLoading"
            class="fa fa-spinner fa-spin"
          /> Submit
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import bModal from 'bootstrap-vue/es/components/modal/modal'
import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'

import PasswordRePasswordComponent from './PasswordRePasswordComponent.vue'

export default {

	components: {
		PasswordRePasswordComponent
	},
	props: {
		initialEmail: {
			type: String,
			required: true
		},
		oldPassword: {
			type: String,
			required: true
		}
	},

	data () {
		return {
			showLoading: false,
			showPasswordError: false,
			showPasswordNotMatchingError: false
		}
	},

	methods: {
		clickedSubmit: function () {
			console.log('clickedSubmit this.initialEmail : ' + this.initialEmail)
			console.log('clickedSubmit this.oldPassword : ' + this.oldPassword)

			console.log('clickedSubmit 1')
			/*
      if (!this.showLoading) {
        console.log("clickedSubmit 2");

        this.$refs.passwordRePasswordRef.resetShowErrors();

        // Password don't match
        if (this.$refs.passwordRePasswordRef.validate()) {
          console.log("clickedSubmit All Good");

          this.showLoading = true;

          var poolData = {
            UserPoolId: ENV_CONFIG.pool_id, // Your user pool id here
            ClientId: ENV_CONFIG.client_id // Your client id here
          };

          var userPool = new CognitoUserPool(poolData);

          var userData = {
            Username: this.email,
            Pool: userPool
          };

          var reference = this;

          var cognitoUser = new CognitoUser(userData);

          const params = {
            email: this.initialEmail
          };

          cognitoUser.completeNewPasswordChallenge(
            this.$refs.passwordRePasswordRef.getPassword(),
            params,
            {
              onSuccess: function(result) {
                console.log(result);

                reference.showLoading = false;

                reference.$root.$emit(
                  "bv::hide::modal",
                  "reset-password-modal"
                );

                utils.makeToast(reference, "Success", "success", "You have successfully updated your password");
                //$('#form-signin').
                document.getElementById("form-signin").reset();
              },

              onFailure: function(err) {
                console.log(err);

                reference.showLoading = false;

                utils.makeToast(reference,"Error", "danger", "Your password couldn't be updated");
              }
            }
          );
        }
      } else {
        console.log("clickedSendPassword already loading");
      }
      */
		}
	}
}
</script>

<style lang="stylus" scoped>
h1 {
  color: green;
}

#footer-button {
  width: 100%;
  padding: 0.4rem;
  font-size: 14pt;
}

#forgot-password-input-container {
  text-align: left;
}
</style>
